export type Language = 'en' | 'ru'

const key = 'nitea.language'

const stored = (): Language | undefined => {
  try {
    const saved = localStorage.getItem(key)
    return saved === 'en' || saved === 'ru' ? saved : undefined
  } catch {
    return undefined
  }
}

const fromTelegram = (): Language => {
  const code = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code ?? ''
  return code.startsWith('ru') ? 'ru' : 'en'
}

export const language: Language = stored() ?? fromTelegram()

export const storeLanguage = (next: Language): void => {
  try {
    localStorage.setItem(key, next)
  } catch {
    return
  }
}

export const setLanguage = (next: Language): void => {
  if (next === language) return
  storeLanguage(next)
  window.location.reload()
}
